//config
export * from './products-config'

export * from './lib/products-detail/products-detail'
export * from './lib/constants'
export * from './lib/components/add-to-cart-dialog/add-to-cart-dialog'
export * from './lib/components/add-to-cart-purchase-history-dialog/add-to-cart-purchase-history-dialog'
export * from './lib/components/edit-price-dialog/edit-price-dialog'
export * from './lib/components/remove-from-cart-dialog/remove-from-cart-dialog'
export * from './lib/components/availability-chip/availability-chip'
export * from './lib/components/category-chip/category-chip'
export * from './interfaces/product.model'
export * from './interfaces/cart.model'
export * from './services/products.service'
export * from './services/cart.service'
